<script setup lang="ts">
import IconMenu from 'assets/icons/menu.svg';

const isOpen = ref(false);

const onClose = () => {
  isOpen.value = false;
};
</script>

<template>
  <div
    v-click-outside="onClose"
    class="lg:hidden"
  >
    <ButtonActive
      :active="isOpen"
      class="w-fit"
      type="2"
      @click="isOpen = !isOpen"
    >
      <template #append>
        <IconMenu class="w-[15px] h-[11px]" />
      </template>
    </ButtonActive>

    <div
      v-if="isOpen"
      class="absolute left-0 w-full max-md:h-[calc(100dvh_-_57px)] max-lg:h-[calc(100dvh_-_72px)] h-[calc(100dvh_-_121px)] max-md:p-4 px-[80px] z-10"
    >
      <div class="w-full h-full shadow-highlight-2 bg-gray-100 px-6 pt-8 pb-7 rounded-big flex flex-col justify-between">
        <div>
          PANEL Mobile
        </div>

        <!--        <div class="bg-gray-300 w-full h-[1px]" /> -->
        <div class="flex justify-between items-cente">
          <AuthBlock />
          <div class="flex gap-4 items-end">
            <LanguageSelect vertical="up" />
            <CartButton @click="onClose" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
